
/**
* 
* @desc 关于验证类 
* 
*/
const checkCode = {
  phone: (phone) => {
    if (!(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(phone))) {
      return false;
    } else {
      return true;
    }
  },
  qqnumber: (qqnumber) => {
    if (!(/^[1-9][0-9]{4,10}$/.test(qqnumber))) {
      return false;
    } else {
      return true;
    }
  },
  number4: (number4) => {
    if (!(/^[\d]{4}$/.test(number4))) {
      return false;
    } else {
      return true;
    }
  }
}

/**
* 
* @desc 关于下载 
* 
*/
const downloadFn = {
  /**
  * 
  * @desc 下载图片 
  * 
  */
  downloadIamge: (imgsrc, name) => {
    //下载图片地址和图片名
    let image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute("crossOrigin", "anonymous");
    image.onload = function () {
      let canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      let context = canvas.getContext("2d");
      context.drawImage(image, 0, 0, image.width, image.height);
      let url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
      let a = document.createElement("a"); // 生成一个a元素
      let event = new MouseEvent("click"); // 创建一个单击事件
      a.download = name || new Date().getTime(); // 设置图片名称
      a.href = url; // 将生成的URL设置为a.href属性
      a.dispatchEvent(event); // 触发a的单击事件
    };
    image.src = imgsrc;
  },

  /**
  * 
  * @desc 下载视频
  * 
  */
  downloadVideo: (url, name) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = name || new Date().getTime();
    a.click();
    a.remove();
  }
}


/**
* 
* @desc 关于转换
* 
*/
const changeParamTypeFn = {
  /**
   * @desc json转&参数
   */
  jsonToString: (query) => {
    let str = []
    for (let key in query) {
      str.push(key + '=' + query[key])
    }
    let paramStr = str.join('&')
    return paramStr
  },
  /**
   * @desc &转json参数
   */
  stringToJson: (query) => {
    let arr = query.split('&');
    let obj = {}
    for (let i of arr) {
      let str = i.split('=');
      let obj1 = {};
      obj1[str[0]] = str[1]
      obj = Object.assign(obj1, obj)
    }
    return obj
  },
}


/**
  * @desc 获取地址栏数据
  */
const getUrlParam = {
  // 获取浏览器上传递地址 getQueryString("startDate")
  getUrlQueryString: (name) => {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]); return null;
  },
  // 获取去地址栏数据（#前后都可以获取）
  getUrlValue: (name) => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ["", ""])[1].replace(/\+/g, '%20')) || null
  },
}

export default {
  // 校验数据
  checkCode,
  // 下载
  downloadFn,
  // 关于转换
  ...changeParamTypeFn,
  // 获取地址栏数据
  ...getUrlParam,
}